import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import VideoBanner from './components/VideoBanner';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <VideoBanner />
  </React.StrictMode>
);
